import { ReactElement } from 'react';
import './ContentWrapper.scss';

interface ContentWrapperProps {
    children: ReactElement;
}

export default function ContentWrapper({ children }: Readonly<ContentWrapperProps>) {
    return (
        <div className="content-wrapper">
            {children}
        </div>
    )
}